export function getInitials(name: string): string {
    if (!name) {
        return '';
    }
    const parts = name.trim().split(/\s+/);
    return parts.slice(0, 2).map(p => p[0]?.toUpperCase() || '').join('');
}
